import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import img21 from "../assest/images/img21.jpg";
import img22 from "../assest/images/img22.jpg";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
// import { FaWhatsapp } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import { apiRequest } from "../services/allApi";
import { errorAlert, successAlert } from "../services/sweetAlert";
import Loader from "../component/loader.jsx";

// import img26 from "../assest/images/img26.jpg";

function Footer() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);

  const [siteData, setSiteData] = useState([]);

  const SiteApi = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("site-settings");
      setIsLoading(false);
      if (res?.success) {
        setSiteData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const [galleryData, setGalleryData] = useState([]);

  const Gallery = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("gallery");
      setIsLoading(false);
      if (res?.success) {
        setGalleryData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log("Site settings error", error);
    }
  };

  useEffect(() => {
    SiteApi();
    Gallery();
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  const socialLinks = [
    {
      icon: "facebook-f",
      link: siteData?.facebook_url,
    },
    {
      icon: "twitter",
      link: siteData?.twitter_link,
    },
    {
      icon: "youtube",
      link: siteData?.youtube_link,
    },
    {
      icon: "instagram",
      link: siteData?.instagram_url,
    },
    {
      icon: "linkedin",
      link: siteData?.linkedin_url,
    },
  ];
  return (
    <>
      <section className="home-callback bg-color-callback primary-bg py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h5 className="sub-title">CALL TO ACTION</h5>

              <h2 className="section-title">
                READY FOR UNFORGATABLE TRAVEL. REMEMBER US!
              </h2>

              <p>
                Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec
                nemo, rutrum. Vestibulum cumque laudantium.
              </p>
            </div>

            <div className="col-md-4 text-md-end mt-2">
              <Link to="/contact-us" className="outline-btn outline-btn-white">
                Contact Us !
              </Link>
            </div>
          </div>
        </div>
      </section>

      <footer id="colophon" className="site-footer footer-primary">
        <div className="top-footer">
          <div className="container">
            <div className="upper-footer">
              <div className="row">
                {/* Logo + About */}
                <div className="col-lg-3 col-sm-6">
                  <aside className="widget widget_text">
                    <div className="footer-logo">
                      <a href="/">
                        <img src={siteData?.site_footer_logo} alt="logo" />
                      </a>
                    </div>

                    <div className="textwidget widget-text">
                      {/* <h5 className="text-light">{siteData?.site_name}</h5> */}

                      <p>
                        {" "}
                        <FaMapMarkerAlt /> {siteData?.site_address}
                      </p>
                      <p>Client: {siteData?.site_footer_text}</p>
                      {/* {console.log(siteData)}
                      <p>Client: Stanzin Chosphel</p> */}
                    </div>
                  </aside>
                </div>

                {/* Recent Post */}
                <div className="col-lg-3 col-sm-6">
                  <aside className="widget widget_latest_post widget-post-thumb">
                    <h3 className="widget-title">RECENT POST</h3>

                    <ul>
                      <li>
                        <figure className="post-thumb">
                          <a href="/blog-archive">
                            <img src={img21} alt="" />
                          </a>
                        </figure>

                        <div className="post-content">
                          <h6>
                            <a href="/blog-single">
                              BEST JOURNEY TO PEACEFUL PLACES
                            </a>
                          </h6>

                          <div className="entry-meta">
                            <span className="posted-on">
                              <a href="/blog-archive">February 17, 2022</a>
                            </span>
                          </div>
                        </div>
                      </li>

                      <li>
                        <figure className="post-thumb">
                          <a href="/blog-archive">
                            <img src={img22} alt="" />
                          </a>
                        </figure>

                        <div className="post-content">
                          <h6>
                            <a href="/blog-single">
                              TRAVEL WITH FRIENDS IS BEST
                            </a>
                          </h6>

                          <div className="entry-meta">
                            <span className="posted-on">
                              <a href="/blog-archive">February 17, 2022</a>
                            </span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </aside>
                </div>

                {/* Contact */}
                <div className="col-lg-3 col-sm-6">
                  <aside className="widget widget_text">
                    <h3 className="widget-title">CONTACT US</h3>

                    <div className="textwidget widget-text">
                      <p>
                        Feel free to contact and <br /> reach us !!
                      </p>

                      <ul>
                        <li>
                          <a href="tel:+919797479722">
                            <FaPhone />
                            {/* +91 9797479722 */}
                            {siteData?.site_contact_number}
                          </a>
                        </li>

                        <li>
                          <a href="mailto:tanzinchosphel004@gmail.com">
                            <FaEnvelope />

                            {siteData?.site_email_address}
                          </a>
                        </li>

                        {/* <li>
                        
                          {siteData?.site_address}
                        </li> */}
                        {/* Footer Menu */}
                        <div className="footer-menu">
                          <ul>
                            <li>
                              <a href="/privacy-policy">Privacy Policy</a>
                            </li>
                            <li>
                              <a href="/terms-and-conditions">
                                Term & Condition
                              </a>
                            </li>
                          </ul>
                        </div>
                      </ul>
                    </div>
                  </aside>
                </div>

                {/* Gallery */}
                <div className="col-lg-3 col-sm-6">
                  <aside className="widget">
                    <h3 className="widget-title">Popular Pages</h3>

                    <Link to="/popular/ladakh-tour-packages-from-hyderabad">
                      Ladakh Tour Packages From Hyderabad
                    </Link>

                    <Link to="/popular/ladakh-tour-packages-from-ahmedabad">
                      Ladakh Tour Packages From Ahmedabad
                    </Link>

                    <Link to="/popular/ladakh-tour-packages-from-bangalore">
                      Ladakh Tour Packages From Bangalore
                    </Link>

                    <Link to="/popular/ladakh-tour-packages-from-delhi">
                      Ladakh Tour Packages From Delhi
                    </Link>
                  </aside>

                  <div
                    className="social-icon"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <ul>
                      {socialLinks.map((item, i) =>
                        item.link ? ( // agar link hai tabhi show hoga
                          <li key={i}>
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className={`text-light fab fa-${item.icon}`}></i>
                            </a>
                          </li>
                        ) : null,
                      )}

                      {/* WhatsApp */}
                      {siteData?.site_contact_number && (
                        <li>
                          <a
                            href={`https://wa.me/${siteData.site_contact_number.replace(
                              /\D/g,
                              "",
                            )}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <FaWhatsapp className="text-light whatsapp-icon" />
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="bottom-footer">
          <div className="container">
            <div className="copy-right text-center">
              Copyright 2026 Ladakh MotoDrive. All rights reserved.
            </div>
          </div>
        </div>
      </footer>

      {/* ===== WHATSAPP FLOAT BUTTON ===== */}
      <a
        href={`https://wa.me/${siteData?.site_contact_number?.replace(/\D/g, "")}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <FaWhatsapp />
      </a>
    </>
  );
}

export default Footer;
